import { environmentHttpClient as httpClient } from "client/Api/httpClient";

export type AppLinkNavigationModel = {
	environmentAppId: number;
	requireIntegrationCredentialsToBeProvidedFirst: false;
	hasNoAccessToTheExternalApplication: false;
	url: string;
} | {
	environmentAppId: number;
	requireIntegrationCredentialsToBeProvidedFirst: true;
	hasNoAccessToTheExternalApplication: false;
} | {
	environmentAppId: number;
	requireIntegrationCredentialsToBeProvidedFirst: false;
	hasNoAccessToTheExternalApplication: true;
};

export interface AppLinkViewModel {
	url: string | null;
}

export function get(environmentAppId: number, signal: AbortSignal): Promise<AppLinkViewModel> {
	return httpClient.get<AppLinkViewModel>(
		`AppLink/${environmentAppId}`,
		undefined,
		{ signal }
	);
}

export function create(environmentAppId: number): Promise<string> {
	return httpClient.post<string>(`AppLink/${environmentAppId}`);
}

export function deleteRequest(environmentAppId: number): Promise<void> {
	return httpClient.delete<void>(`AppLink/${environmentAppId}`);
}
